import React, { useContext } from 'react';
import { Button } from '../ui/Button';
import { NavigationContext, CartContext } from '../../App';
// Product images from Christiana's collection
const IMAGES = {
  blackPeplum: 'https://cdn.magicpatterns.com/uploads/k3nbovxYYDH3962AQgD28u/photo_2026-02-04_04-57-03.jpg',
  brownPleated: 'https://cdn.magicpatterns.com/uploads/dyohvQLDScUhskTJ884wYi/photo_2026-02-04_04-57-01.jpg',
  purpleFringe: 'https://cdn.magicpatterns.com/uploads/rrAJzJnT1RaD9iNVi3fG4e/photo_2026-02-04_04-57-00.jpg',
  tealSuit: 'https://cdn.magicpatterns.com/uploads/3hrnMEGcTHukVuERpb86Hi/photo_2026-02-04_04-57-05.jpg',
  greenMaxi: 'https://cdn.magicpatterns.com/uploads/n3jybvjJ42ADZp6V5BmhiN/photo_2026-02-04_04-57-04.jpg',
  goldPleated: 'https://cdn.magicpatterns.com/uploads/ksWTzFirUa358KYJesShzR/photo_2026-02-04_04-56-59.jpg',
  blackEmbroidered: 'https://cdn.magicpatterns.com/uploads/8Pmu6fAwDDrQ92G1L4HjJg/photo_2026-02-04_04-56-58.jpg',
  emeraldSuit: 'https://cdn.magicpatterns.com/uploads/wYFN1VGG9zCp3b6QMLCMkr/photo_2026-02-04_04-56-56.jpg'
};
const relatedProducts = [{
  id: 2,
  name: 'Gold Puff Sleeve Pleated Gown',
  price: '$225.00',
  image: IMAGES.goldPleated
}, {
  id: 3,
  name: 'Black & Gold Embroidered Kaftan',
  price: '$245.00',
  image: IMAGES.blackEmbroidered
}, {
  id: 4,
  name: 'Emerald Crystal Belted Suit',
  price: '$195.00',
  image: IMAGES.emeraldSuit
}, {
  id: 5,
  name: 'Green Embroidered Maxi Dress',
  price: '$175.00',
  image: IMAGES.greenMaxi
}];
export function RelatedProducts() {
  const {
    navigate
  } = useContext(NavigationContext);
  const {
    addToCart
  } = useContext(CartContext);
  const handleAddToCart = (product: (typeof relatedProducts)[0]) => {
    addToCart({
      id: product.id,
      name: product.name,
      price: parseFloat(product.price.replace('$', '')),
      size: 'M',
      color: 'Default',
      quantity: 1,
      image: product.image
    });
  };
  return <section className="py-16 sm:py-20 bg-[#FDF8F3]" data-id="element-391">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-392">
        <div className="text-center mb-12" data-id="element-393">
          <p className="text-sm uppercase tracking-[0.2em] text-[#6B5B4F] mb-2 font-['Raleway']" data-id="element-394">
            You May Also Like
          </p>
          <h2 className="text-3xl sm:text-4xl font-['Playfair_Display'] text-[#5C3D2E]" data-id="element-395">
            Complete Your Look
          </h2>
          <div className="w-12 h-[2px] bg-[#D4A853] mx-auto mt-4" data-id="element-396" />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8" data-id="element-397">
          {relatedProducts.map(product => <div key={product.id} className="group" data-id="element-398">
              <div onClick={() => navigate('product')} className="w-full aspect-[3/4] mb-4 relative overflow-hidden cursor-pointer bg-[#F5E6D3]" data-id="element-399">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-400" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" data-id="element-401" />

                <div className="absolute bottom-0 left-0 w-full p-2 sm:p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" onClick={e => e.stopPropagation()} data-id="element-402">
                  <Button className="w-full bg-[#5C3D2E] text-white hover:bg-[#D4A853] hover:text-[#1A1A1A] text-xs sm:text-sm" size="sm" onClick={() => handleAddToCart(product)} data-id="element-403">
                    Add to Cart
                  </Button>
                </div>
              </div>

              <div className="space-y-1" data-id="element-404">
                <h3 onClick={() => navigate('product')} className="text-base sm:text-lg font-['Playfair_Display'] text-[#5C3D2E] group-hover:text-[#D4A853] transition-colors cursor-pointer leading-snug" data-id="element-405">
                  {product.name}
                </h3>
                <p className="text-base text-[#6B5B4F] font-['Raleway'] font-medium" data-id="element-406">
                  {product.price}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}